export default "__VITE_ASSET__Cd2qjVCy__"